// Owner 2026-10-15/16 (requirement 61): layar produksi helpers. No imports, so Jest can test them.

export const DESAIN = { lebar: 1280, tinggi: 720 };  // the screen is drawn at this size, then scaled

// Scale that fits the 16:9 design into the TV's CSS viewport (often 960×540 or 1280×720).
export function skala(lebar, tinggi) {
  if (!lebar || !tinggi) return 1;
  return Math.min(lebar / DESAIN.lebar, tinggi / DESAIN.tinggi);
}

// Next schedule item today (items sorted by "HH:MM") and the minutes left; null after the last.
export function berikutnya(jadwal, jamMenit) {
  const [h, m] = jamMenit.split(":").map(Number);
  const kini = h * 60 + m;
  for (const j of jadwal || []) {
    const [jh, jm] = j.jam.split(":").map(Number);
    const t = jh * 60 + jm;
    if (t > kini) return { ...j, sisaMenit: t - kini };
  }
  return null;
}

// "1 jam 05 menit" / "12 menit" / "kurang dari 1 menit"
export function teksMundur(menit) {
  if (menit == null) return "";
  if (menit < 1) return "kurang dari 1 menit";
  const j = Math.floor(menit / 60);
  const m = menit % 60;
  return j ? `${j} jam ${String(m).padStart(2, "0")} menit` : `${m} menit`;
}

// Announcement queue: add the new ones (never twice), highest priority first, then oldest.
export function antre(lama, baru) {
  const ada = new Set(lama.map((k) => k.seq));
  return [...lama, ...baru.filter((k) => !ada.has(k.seq))]
    .sort((a, b) => a.prioritas - b.prioritas || a.seq - b.seq);
}

// v2.16-A: a move to the next station with `bunyi` is a short sound only; v2.18.1: without it, it is read out
// (setting "Dibacakan": one announcement per minute, the server groups the moves).
export const hanyaBunyi = (k) => k.jenis === "PINDAH_POS" && Boolean(k.bunyi);

// Which announcement types are switched on (server setting tv_suara_kejadian).
export const boleh = (k, aktif) => !aktif || aktif[k.jenis] !== false;

// A TV left open loads a new app version only during the quiet hours (nobody listens then).
export const muatUlangSekarang = (adaBaru, tenang) => Boolean(adaBaru && tenang);

// The Indonesian voice of the browser, if any (null: tone + big text only).
export function suaraIndonesia(daftar) {
  const v = (daftar || []).filter((x) => /^id([-_]|$)/i.test(x.lang || ""));
  return v.find((x) => x.localService) || v[0] || null;
}
